class BESSAppDaylightProfilerManager extends BESSAppProjectProfilerManager {

    constructor(profiler) {
        super(profiler);
        this.#updateTotals();
        this.#updateDaylightPassFail();
    }


    updated() {
        super.updated();
        this.#updateTotals();
        this.#updateDaylightPassFail();
    }

    #updateTotals() {
        this.totalRooms = 0;
        this.totalBedRooms = 0;
        this.totalLivingRooms = 0;
        this.totalArea = 0;
        this._forEachItem(this.#updateTotalsForItem);

        let totalsContent =
            this._createTotalItemContent(this.totalRooms, 'Total ' + pluralise('room', 'rooms', this.totalRooms)) +
            this._createTotalItemContent(this.totalBedRooms, pluralise('Bedroom', 'Bedrooms', this.totalBedRooms)) +
            this._createTotalItemContent(this.totalLivingRooms, pluralise('Living Room', 'Living Rooms', this.totalLivingRooms)) +
            this._createTotalItemContent(Math.floor(this.totalArea), 'Total floor area (Square Metres)');

        this.profiler.showTotals(totalsContent);
    }

    #updateTotalsForItem(item) {
        let quantity = item.values[this.profiler.data.getFieldNoForAttribute('quantity')].value;
        let area = item.values[this.profiler.data.getFieldNoForAttribute('roomFloorArea')].value;
        let typeFieldNo = this.profiler.data.getFieldNoForAttribute('roomDesignation');
        let type = item.values[typeFieldNo].getChoice(
            this.profiler.data.fields[typeFieldNo]
        );
        if (quantity === null || quantity === undefined) {
            quantity = 0;
        }
        if (area === null || area === undefined) {
            area = 0;
        }
        this.totalRooms += quantity;
        this.totalArea += (area * quantity);
        if (type !== null) {
            if (type.value === 'Bedroom') {
                this.totalBedRooms += quantity;
            } else if (type.value === 'Living') {
                this.totalLivingRooms += quantity;
            }
        }
    }

    #updateDaylightPassFail() {
        this._forEachItem(this.#updateDaylightPassFailForItem);
    }

    #updateDaylightPassFailForItem(itemData, itemNo) {
        let passFail = itemData.values[this.profiler.data.getFieldNoForAttribute("daylightCriteriaAchieved")].value;
        let item = this.profiler.items[itemNo];
        if (item) {
            let fieldView = item.fieldViewForAttribute("daylightCriteriaAchieved");
            fieldView.addClassIf('pass', passFail);
            fieldView.addClassIf('fail', !passFail);
        }
    }
}